import { render, staticRenderFns } from "./salary_allpay.vue?vue&type=template&id=33c6197c&scoped=true"
import script from "./salary_allpay.vue?vue&type=script&lang=js"
export * from "./salary_allpay.vue?vue&type=script&lang=js"
import style0 from "./salary_allpay.vue?vue&type=style&index=0&id=33c6197c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c6197c",
  null
  
)

export default component.exports